export default __webpack_public_path__ + "static/media/ReportsOrange.b58d4b75.png";